import React, {useRef, useState} from "react";
import TextareaAutosize from "react-textarea-autosize";
import "../../../styles/components/chat/ChatInput.css";
import { ArrowForward } from "@mui/icons-material";
// import { ReactComponent as Stop } from "../../../images/stop-circle-bold.svg";
import { CircularProgress, Tooltip, Typography } from "@mui/material";
import axios from "axios";

const ChatInput = ({ isThinking, getResponseForRef, textareaRef, keywords, selectedChat }) => {
  const [chatText, setChatText] = useState("");

  const setQuery = ($event) => {
    // Update chatText with the input text
    const updatedText = $event.target.value;
    setChatText(updatedText);
    // Check if the pressed key is "Enter"
    if ($event.key === "Enter" && updatedText!='') {
      // $event.preventDefault(); // Prevent the default behavior of form submission
      getResponseForRef(updatedText);
      $event.target.value = ""; // Clear the input field
    }
  };

  const handleSubmit = () =>{
    getResponseForRef(chatText)
    // textAreaRef.current.value = ""; // Clear the input field
  }

  // Only render if no chat is selected
  if (selectedChat) {
    return null;
  }

  return (
    <>
      <div className="chat-input">
        <Tooltip
          title={
            keywords.length === 0 && (
              <Typography color="inherit" sx={{ fontWeight: 'bold' }}>
                First select documents after searching using query builder
              </Typography>
            )
          }
          disableHoverListener={keywords.length !== 0}
          disableFocusListener={keywords.length !== 0}
          disableTouchListener={keywords.length !== 0}
          placement="top"
          arrow
          sx={{ maxWidth: 500 }}
        >
          <div className="chat-input-box" style={{ 
            borderColor: keywords.length === 0 ? "gray" : "" 
          }}>
            <TextareaAutosize
              rows={1}
              ref={textareaRef}
              minRows={1}
              maxRows={9}
              disabled={keywords.length === 0}
              className="chat-input-textarea-field"
              placeholder="Ask Tax Genii anything......"
              onChange={setQuery}
            />
          </div>
        </Tooltip>
        {!isThinking && chatText && (
          <button className="chat-input-button-send" onClick={handleSubmit}>
            <ArrowForward />
          </button>
        )}
        {isThinking && (
          <button className="chat-input-button-send" >
            <CircularProgress color="primary" size={30} sx={{ svg: { width: "30px", height: "30px" } }} />
          </button>
        )}
      </div>
    </>
  );
};

export default ChatInput;
